/**
 * HE.Web.Image
 */

(function Image($, HE)
{
	"use strict";
	var image            = {};
	var gallery_cache    = new Map(); // eslint-disable-line no-undef
	var dead_cache       = [];
	var gallery_defaults = {
		download : false,
		thumbnail: true,
	};

	image.reportDeadImages = HE.Debounce(function reportDeadImages(giata_id) {
		HE.Ajax.post('/Hotels/reportDeadImages', {
			giata_id: giata_id,
			images  : dead_cache,
		})
		.then(function reportedDeadImages() {
			dead_cache = [];
		});
	}, 500);

	function initAjaxGallery(el, opts)
	{
		var $el      = $(el);
		var giata_id = $el.data('giata-id') || $el.parent().data('giata-id');
		var featured = (($el.data('featured')) ? $el.data('featured') : 0);
		var url      = '/Hotels/gallery/' + giata_id + '/' + featured;
		var _opts    = $.extend({
			dynamic: true,
		}, gallery_defaults, opts);

		if (!giata_id) {
			throw new Error('missing giata-id');
		}

		if (gallery_cache[url]) {
			_opts.dynamicEl = gallery_cache[url];
			$el.lightGallery(_opts);
		}
		else {
			HE.Ajax.get(url).then(function _showGallery(images)
			{
				// cache response
				gallery_cache[url] = images;

				if (images.length) {
					_opts.dynamicEl = images;
					$el.lightGallery(_opts);
				}
				else {
					HE.StatusMessage('error', 'No images available for this property.');
				}
			});
		}
	}

	// auto-init ajax-loaded galleries
	$(document).on('click', '.ajax-image-gallery', function initAjaxImageGallery() {
		initAjaxGallery(this);
	});

	// auto-init inline galleries
	$(document).on('click', '.inline-image-gallery', function initInlineImageGallery()
	{
		var $self      = $(this),
		    image_json = $self.data('gallery-images'),
		    _opts;

		if (!image_json.length) {
			return;
		}

		_opts = $.extend({
			dynamic  : true,
			dynamicEl: image_json,
		}, gallery_defaults);

		$self.lightGallery(_opts);
	});

	$(document).on('onAfterOpen.lg', function slideToIndex(e)
	{
		// go to specific image, if index provided
		var $target  = $(e.target),
		    gallery  = $target.data('lightGallery'),
		    index    = $target.data('index'),
		    giata_id = $target.parents('[data-giata-id]').data('giata-id');

		if (index) {
			gallery.slide(index);
		}

		// dead image reporting
		// img error event does not bubble up in any browser, for mystery reasons!
		// so, each time lg opens, set an error handler on all the images.
		$('.lg-outer').find('img').on('error', function collectDeadImages() {
			dead_cache.push(this.src);
			HE.Web.Image.reportDeadImages(giata_id);
		});
	});


	HE.Web.Image = image;
}(jQuery, window.HE || {}));
